// app/features/user-profile/services_and_hooks/userProfileService.ts
import { UserProfile } from '../user-profile.interface';

export const userProfileService = {
  async getUserProfile(userId: string, orgId: string): Promise<UserProfile> {
    const response = await fetch(`/api/platform-users/${userId}?orgId=${orgId}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch user profile');
    }
    
    return response.json();
  }
};

